export default [
  { value: 'CA', label: 'Canada' },
  { value: 'US', label: 'United States' },
]
